import { websocketUrl } from "@/config/http";

let websocket;
let websocket2;
let listeners = {};
let targetOrgId = "";
let timestamp = 0;
let timer = null;

function onopen() {
    // console.log("数据通知服务连接成功");
}

function onerror() {
    // console.log("数据通知服务连接错误");
}

function onmessage(msg) {
    let parts = msg.data.split(":");
    let now = new Date().getTime();
    if (Object.keys(listeners).length > 0 && parts.length == 3 && (parts[2] == targetOrgId || targetOrgId == "0") && now - timestamp > 10000) {
        console.log("收到消息：" + parts[0]);
        timestamp = new Date().getTime();
        for (let key in listeners) {
            listeners[key](parts[0], parts[1])
        }
        if (parts[0] == "report") {
            if (timer != null) {
                clearTimeout(timer)
            }
            timer = setTimeout(() => {
                timestamp = new Date().getTime();
                for (let key in listeners) {
                    listeners[key](parts[0], parts[1])
                }
            }, 60000)
        }
    }
}

export function initWebsocket(userid, orgId) {
    if (typeof (WebSocket) !== "undefined") {
        targetOrgId = orgId;
        websocket = new WebSocket(websocketUrl + "/" + userid);
        websocket.onopen = onopen;
        websocket.onerror = onerror;
        websocket.onmessage = onmessage;
    }
}

export function testWebsocket() {
    if (typeof (WebSocket) !== "undefined") {
        websocket2 = new WebSocket(websocketUrl + "/BSY@BQQ85JFDHI52DU53YDP4CNFHPA7TWOTG");
        websocket2.onopen = () => {
            console.log("中医报告通知服务连接成功");
        };
        websocket2.onerror = () => {
            console.log("中医报告通知服务连接错误");
        };
        websocket2.onmessage = (msg) => {
            console.log(msg.data);
        };
    }
}

export function registerListener(name, listener) {
    listeners[name] = listener;
}